module.exports = __webpack_public_path__ + "img/timconwayjr_hero_desktop.c1220793.png";